import { useContext, useEffect } from "react";
import { SearchVehicleByVinDataContext } from "../SearchVehicleByVinDataProvider";
import { SearchVehicleDataContextType, SetSearchVehicleDataContextType } from "../types";
import { useSearchParams } from "react-router-dom";

/**
 * Установка параметров из URL
 * @param {React.ReactNode} children - Дочерние компоненты
 * @returns {React.ReactNode}
 */
export const SetSearchParams = ({ children }: { children: React.ReactNode }) => {
    const { vin, carNumber, carNumberRegion, vehicleId, catalog, ssd, setVin, setCarNumber, setCarNumberRegion, setVehicleId, setCatalog, setSsd } = useContext(SearchVehicleByVinDataContext) as SearchVehicleDataContextType & SetSearchVehicleDataContextType;
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const vinParams = searchParams.get('vin');
        const carNumberParams = searchParams.get('carNumber');
        const carNumberRegionParams = searchParams.get('carNumberRegion');
        const vehicleIdParams = searchParams.get('vehicleId');
        const catalogParams = searchParams.get('catalog');
        const ssdParams = searchParams.get('ssd');

        if (vinParams && vinParams !== vin) {
            setVin(vinParams);
        }
        if (carNumberParams && carNumberParams !== carNumber) {
            setCarNumber(carNumberParams);
        }
        if (carNumberRegionParams && carNumberRegionParams !== carNumberRegion) {
            setCarNumberRegion(carNumberRegionParams);
        }
        if (vehicleIdParams && vehicleIdParams !== vehicleId) {
            setVehicleId(vehicleIdParams);
        }
        if (catalogParams && catalogParams !== catalog) {
            setCatalog(catalogParams);
        }
        if (ssdParams && ssdParams !== ssd) {
            setSsd(ssdParams);
        }
    }, []);

    return children;
};